import { render } from "./LayoutNoFooter.vue?vue&type=template&id=643790d3"
import script from "./LayoutNoFooter.vue?vue&type=script&lang=ts"
export * from "./LayoutNoFooter.vue?vue&type=script&lang=ts"
script.render = render

export default script